// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import 'antd/dist/reset.css';
import './index.css';
import store from './store';
import App from './App';

import { initKeycloak, keycloak } from './auth/keycloak';

// Optional: simple action; replace with your real slice action
const setAuthUser = (user) => ({ type: 'auth/userSet', payload: user });

function readUserFromToken() {
  const t = keycloak.tokenParsed || {};
  console.log("groups :", t.groups);
  console.log("token :", t);
  return {
    username: t.preferred_username || t.name || '',
    groups: t.groups || [],
    email: t.email || null,
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));

initKeycloak().then(() => {
  // 1) on first load
  store.dispatch(setAuthUser(readUserFromToken()));

  // 2) keep Redux in sync on auth events / refresh
  keycloak.onAuthSuccess = () => {
    store.dispatch(setAuthUser(readUserFromToken()));
  };
  keycloak.onAuthRefreshSuccess = () => {
    store.dispatch(setAuthUser(readUserFromToken()));
  };
  keycloak.onTokenExpired = async () => {
    try {
      await keycloak.updateToken(30);
      store.dispatch(setAuthUser(readUserFromToken()));
    } catch {}
  };

  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
});
